
export interface selectedProfile{
	selectedProfile: string
}

export const initialSelectedProfile: selectedProfile = {
	selectedProfile: 'none'
}

